import React from 'react';

const LoginPage: React.FC = () => {
  return <div>登录页面</div>;
};

export default LoginPage; // 确保有这个默认导出